module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-1.5adb7c91.png";